import useIsAdminPage from './useIsAdminPage'
import useIsClientPage from 'hooks/useIsClientPage'

export default function useIsPublicPage() {
  const isAdminPage = useIsAdminPage()
  const isClientPage = useIsClientPage()

  return !isAdminPage && !isClientPage
}
